import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { COMPANY_NAME } from "../../config/constants";
import { useTranslation } from "../../context/TranslationContext";
import { LanguageSelector } from "../common/LanguageSelector";
import { NavigationButton } from "../ui/NavigationButton";

export const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [hasScrolled] = useState(true);
  const { t } = useTranslation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header
      className={`fixed text-black top-0 left-0 right-0 z-50 transition-all duration-300 ${
        hasScrolled
          ? "bg-white/75 backdrop-blur-md shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="app-container min-w-full px-10">
        <div className="flex items-center gap-2 p-2">
          {/* Desktop Navigation */}
          <div
            className={`font-bold outfit text-xl transition-opacity duration-300 tracking-wide
 ${hasScrolled ? "opacity-100" : "opacity-0"}`}
          >
            {COMPANY_NAME}
          </div>
          <nav className="hidden md:flex items-center space-x-8 font-semibold ml-auto">
            <NavigationButton text={t("nav.about")} link={"#about"} />
            <NavigationButton text={t("nav.services")} link={"#services"} />
            <NavigationButton text={t("nav.fleet")} link={"#fleet"} />
            <NavigationButton text={t("nav.contact")} link={"#contact"} />
          </nav>
          <div className="ml-auto flex">
            <LanguageSelector isScrolled={hasScrolled} />
            {/* Mobile Menu Button */}
            <button
              className="md:hidden p-2 text-black hover:text-primary transition-colors"
              onClick={toggleMenu}
              aria-label="Toggle menu"
            >
              {isMenuOpen ? (
                <X className="w-6 h-6" />
              ) : (
                <Menu className="w-6 h-6" />
              )}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4">
            <nav className="flex flex-col space-y-4">
              <a
                href="#about"
                className="text-neutral hover:text-primary transition-colors"
                onClick={toggleMenu}
              >
                {t("nav.about")}
              </a>
              <a
                href="#services"
                className="text-neutral hover:text-primary transition-colors"
                onClick={toggleMenu}
              >
                {t("nav.services")}
              </a>
              <a
                href="#fleet"
                className="text-neutral hover:text-primary transition-colors"
                onClick={toggleMenu}
              >
                {t("nav.fleet")}
              </a>
              <a
                href="#contact"
                className="text-neutral hover:text-primary transition-colors"
                onClick={toggleMenu}
              >
                {t("nav.contact")}
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
